import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Routes, RouterModule , Router,ActivatedRoute, Params } from '@angular/router';
import { LeadService } from '../lead.service';
import { Observable } from 'rxjs';
import { Lead } from '../lead';
import { AbstractControl, FormControl, FormBuilder, FormArray,FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '../../../services/loader.service';
import { DesignerService } from '../../designer/designer.service';
declare var $:any;

@Component({
  selector: 'app-booking-form',
  templateUrl: './booking-form.component.html',
  styleUrls: ['./booking-form.component.css'],
  providers: [LeadService, LoaderService, DesignerService]
})
export class BookingFormComponent implements OnInit {

	successalert;
  successMessage;
  erroralert;
  errorMessage;
  bookingForm : FormGroup;
  lead_id:any;
  role:any;
  lead_details:any;
  lead_status;

  constructor(
  	public activatedRoute: ActivatedRoute,
    public leadService : LeadService,
    public loaderService : LoaderService,
    public designerService : DesignerService,
    private formBuilder: FormBuilder,
    private route:ActivatedRoute
  ) { }

  ngOnInit() {
  	this.activatedRoute.params.subscribe((params: Params) => {
        this.lead_id = params['leadId'];
      });
    this.route.queryParams.subscribe(params => {
      this.lead_status = params['lead_status'];
    });
    this.role = localStorage.getItem('user');

    this.initBookingForm();
    this.fetchBasicDetails();
    
  }

  fetchBasicDetails(){
    this.leadService.getLeadLogs(this.lead_id).subscribe(
      res => {
        this.lead_details = res['lead'];
        this.bookingForm.patchValue({project_id: this.lead_details.project_details.id});
        this.fetchBookingForm();
        // this.bookingForm.value.project_id = this.lead_details.project_details.id;
      },
      err => {
        console.log(err);
      }
    );
  }

  prev_booking_form:any = {}
  fetchBookingForm(){
  	this.leadService.fetchBookingForm(this.lead_details.project_details.id).subscribe(
  		res => {
        this.prev_booking_form = res['project_booking_form']
        this.updatePrevForm(this.prev_booking_form)
  		},
  		err => {
  			console.log(err);
  			alert("Something went bad. Please try again");
  		});
  }

  updatePrevForm(form){
    this.bookingForm.patchValue({annual_income: form['annual_income']});
    this.bookingForm.patchValue({building_name: form['building_name']});
    this.bookingForm.patchValue({city: form['city']});
    this.bookingForm.patchValue({company: form['company']});
    this.bookingForm.patchValue({current_address: form['current_address']});
    this.bookingForm.patchValue({date: form['date']});
    this.bookingForm.patchValue({designation: form['designation']});
    this.bookingForm.patchValue({flat_no: form['flat_no']});
    this.bookingForm.patchValue({floor_no: form['floor_no']});
    this.bookingForm.patchValue({landline: form['landline']});
    this.bookingForm.patchValue({location: form['location']});
    this.bookingForm.patchValue({order_date: form['order_date']});
    this.bookingForm.patchValue({order_value: form['order_value']});
    this.bookingForm.patchValue({pincode: form['pincode']});
    this.bookingForm.patchValue({possession_by: form['possession_by']});
    this.bookingForm.patchValue({primary_email: form['primary_email']});
    this.bookingForm.patchValue({primary_mobile: form['primary_mobile']});
    this.bookingForm.patchValue({profession: form['profession']});
    this.bookingForm.patchValue({professional_details: form['professional_details']});
    this.bookingForm.patchValue({other_professional_details: form['other_professional_details']});
    this.bookingForm.patchValue({secondary_email: form['secondary_email']});
    this.bookingForm.patchValue({secondary_mobile: form['secondary_mobile']});

  }

  initBookingForm(){
  	this.bookingForm = this.formBuilder.group({
  		project_id : new FormControl(),
  	  flat_no : new FormControl(),
  	  floor_no : new FormControl(),
  	  building_name : new FormControl(),
  	  location : new FormControl(),
  	  city : new FormControl(),
  	  pincode : new FormControl(),
  	  possession_by : new FormControl(),
  	  profession : new FormControl(),
  	  designation : new FormControl(),
  	  company : new FormControl(),
  	  professional_details : new FormControl(),
      other_professional_details: new FormControl(),
  	  annual_income : new FormControl(),
  	  landline : new FormControl(),
  	  primary_mobile : new FormControl(),
  	  secondary_mobile : new FormControl(),
  	  primary_email : new FormControl(),
  	  secondary_email : new FormControl(),
  	  current_address : new FormControl(),
  	  order_value : new FormControl(),
  	  order_date : new FormControl(),
    })
  }

  bookingFormSubmit(){
    if(this.prev_booking_form['id']){
      this.leadService.bookingFormUpdate(this.prev_booking_form['id'],this.bookingForm.value).subscribe(
      res => {
        alert("Form successfully submitted");
      },
      err => {
        console.log(err);
        alert("Something went bad. Please try again");
      });
    }
    else{
      this.leadService.bookingFormSubmit(this.bookingForm.value).subscribe(
      res => {
        alert("Form successfully submitted");
      },
      err => {
        console.log(err);
        alert("Something went bad. Please try again");
      });
    }
  }


}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/booking-form/booking-form.component.ts